export enum ErrorTypes {
    ADD_AUTHORIZED_CUSTOMER = 'Add authorized customer',
    REMOVE_AUTHORIZED_CUSTOMER = 'Remove authorized customer',

    DELETE_GIVEN_EFAKTURA = 'Delete given eFaktura',
    DELETE_RECEIVED_EFAKTURA = 'Delete received eFaktura',

    MOVE_AVTALEGIRO = 'Move AvtaleGiro',
}

export type errorEvent = {
    errorName: string;
    errorDescription: string;
    errorCode: string;
    appNamespace: string;
};
